module.exports = "/_next/static/videos/seller-2-7ee7e1e94aaf415bdb1c19871d68f068.mp4";